import React from "react";
import "./home.css";
import HeaderSocials from "./HeaderSocials";
import projectsData from "../../data/projectsData";

const Home = () => {
  const { name, subtitle, description } = projectsData.home;
  return (
    <section className="home" id="about">
      <div className="intro">
        <h1 className="home_name">{name}</h1>
        <p className="home_subtitle">{subtitle}</p>
        <p className="home_description">{description}</p>
        <p className="home_seo_line">
          Explore my <a href="#experience">experience</a>,
          <a href="#education"> education</a>, <a href="#projects">projects</a>,
          <a href="#skills"> skills</a>, and{" "}
          <a href="#contact">contact details</a>.
        </p>
        <HeaderSocials />
      </div>
    </section>
  );
};

export default Home;
